export const getIsJSON = (str: string): boolean => {
  try {
    return JSON.parse(str) && !!str;
  } catch {
    return false;
  }
};
